<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <span>Inicio de sesión en TecPresence</span>
            </v-toolbar-title>
            <v-dialog v-model="dialog" width="500">
              <ayuda urlFaqs="/faqs-public"></ayuda>
            </v-dialog>

            <template v-slot:extension>
              <v-tabs
                v-model="tabActive"
                centered
                slider-color="yellow"
                background-color="transparent"
              >
                <v-tab key="1" href="#tabEmpleado">Empleado</v-tab>
                <v-tab key="2" href="#tabUsuario">Usuario</v-tab>
                <v-tab hey="3" href="#tabAyuda">
                  <v-icon>live_help</v-icon>
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-card-text>
            <v-tabs-items v-model="tabActive">
              <v-tab-item key="1" value="tabEmpleado">
                <v-form ref="formEmpleado" v-model="validEmpleado" lazy-validation>
                  <v-select
                    prepend-icon="location_city"
                    v-on:keyup="textKeyPressEmpleado"
                    :items="empresas"
                    v-model="empresa"
                    label="Empresa"
                    :rules="empresaRules"
                    item-text="name"
                    item-value="name"
                    required
                  ></v-select>
                  <v-text-field
                    v-on:keyup="textKeyPressEmpleado"
                    v-model="numEmpleado"
                    prepend-icon="person"
                    name="login"
                    label="Número empleado"
                    type="text"
                    :rules="numEmpleadoRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-on:keyup="textKeyPressEmpleado"
                    v-model="contrasena"
                    id="password"
                    prepend-icon="lock"
                    :append-icon="verPwd ? 'visibility' : 'visibility_off'"
                    @click:append="() => (verPwd = !verPwd)"
                    name="password"
                    label="Password"
                    :type="verPwd ? 'text' : 'password'"
                    :rules="contrasenaRules"
                    required
                  ></v-text-field>
                </v-form>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    :loading="loading"
                    color="primary"
                    :disabled="loading"
                    @click="submitEmpleado"
                  >
                    Iniciar sesión
                    <span slot="loader">
                      <small
                        style="text-transform: lowercase; padding: 0 10px; display:inline-block"
                      >iniciando...</small>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-tab-item>
              <v-tab-item key="2" value="tabUsuario">
                <v-form ref="formUsuario" v-model="validEmpleado" lazy-validation>
                  <v-text-field
                    v-on:keyup="textKeyPressUsuario"
                    v-model="usuario"
                    prepend-icon="person"
                    name="login"
                    label="Usuario"
                    type="text"
                    :rules="usuarioRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-on:keyup="textKeyPressUsuario"
                    v-model="contrasena"
                    id="password"
                    prepend-icon="lock"
                    :append-icon="verPwd ? 'visibility' : 'visibility_off'"
                    @click:append="() => (verPwd = !verPwd)"
                    name="password"
                    label="Password"
                    :type="verPwd ? 'text' : 'password'"
                    :rules="contrasenaRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-on:keyup="textKeyPressUsuario"
                    v-model="dominio"
                    prepend-icon="computer"
                    name="dominio"
                    label="Dominio"
                    type="text"
                  ></v-text-field>
                </v-form>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    :loading="loading"
                    color="primary"
                    :disabled="loading"
                    @click="submitUsuario"
                  >
                    Iniciar sesión
                    <span slot="loader">
                      <small
                        style="text-transform: lowercase; padding: 0 10px; display:inline-block"
                      >iniciando...</small>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-tab-item>
              <v-tab-item key="3" value="tabAyuda">
                <ayuda urlFaqs="/faqs-public" elevation="false"></ayuda>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        </v-card>
        <v-snackbar v-model="showError" color="error" :timeout="8000" right>
          {{ status.error }}
          <!-- Usuario/Contraseña incorrectos -->
          <v-btn dark text @click="showError = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import globalService from "@/services/globalService.js";
import authenticationService from "@/services/authenticationService.js";
import ayuda from "@/components/commons/ayuda";
export default {
  data() {
    return {
      verPwd: false,
      tabActive: "tabEmpleado",
      showError: false,
      validEmpleado: true,
      dialog: false,
      loading: false,
      permitLogin: false,
      usuario: "",
      numEmpleado: "",
      dominio: "",
      host: "",
      contrasena: "",
      empresa: "",
      empresas: [],
      empresaRules: [v => !!v || "La Empresa es requerida"],
      usuarioRules: [v => !!v || "El usuario es requerido"],
      dominioRules: [v => !!v || "El dominio es requerido"],
      numEmpleadoRules: [v => !!v || "El número del empleado es requerido"],
      contrasenaRules: [v => !!v || "La contraseña es requerida"]
    };
  },
  computed: mapState("authentication", ["status", "user"]),
  watch: {
    status: function(val) {
      this.loading = val.logging;
      this.showError = !!val.error;
      if (val.logged) {
        if (this.user.userMustChangePassword) {
          this.$router.push("/cambiar-clave");
        } else {
          this.$router.push("/");
        }
      }
    }
  },
  components: { ayuda },
  created() {},
  mounted() {
    var that = this;
    globalService.getEmpresas().then(res => {
      if (!!res && res.length > 0){
        //loginAllowed
        that.empresas = res.filter(empresa => empresa.loginAllowed);
      }
    }).catch(error => {
      this.$router.push("/error-conexion");
    });
    //si no me estoy conectando a la api y no hay conexión, enviamos a la página de error
    if (!this.$store.state.global.conectandoApi && !this.$store.state.global.conexionApi) {
      this.$router.push("/error-conexion");
    }
  },
  methods: {
    textKeyPressUsuario: function(e) {
      if (e.keyCode === 13) {
        this.submitUsuariot();
      }
    },
    textKeyPressEmpleado: function(e) {
      if (e.keyCode === 13) {
        this.submitEmpleado();
      }
    },
    submitUsuario: function() {
      if (this.$refs.formUsuario.validate()) {
        const { usuario, contrasena, dominio, host } = this;
        const { dispatch } = this.$store;
        if (usuario && contrasena) {
          var that = this;
          this.loading = true;
          dispatch("authentication/login", {
            usuario,
            contrasena,
            dominio,
            host
          });
        }
      }
    },
    submitEmpleado: function() {
      if (this.$refs.formEmpleado.validate()) {
        const { empresa, numEmpleado, contrasena } = this;
        const { dispatch } = this.$store;
        if (empresa && contrasena && numEmpleado) {
          var that = this;
          this.loading = true;
          var user = empresa + "\\" + numEmpleado;
          dispatch("authentication/login", {
            usuario: user,
            contrasena,
            dominio: "",
            host: ""
          });
        }
      }
    }
  }
};
</script>
